export { default as Gavinyuetest } from "./components/gavinyuetest";



// WEBPACK FOOTER //
// ./src/index.js